import React from 'react';
import PropTypes from 'prop-types';

const IncrementArrowIcon = (props) => {
  return (
    <div role="button" style={{ cursor: 'pointer' }} onClick={props.onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
        <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M12.3055 16.3914L15.926 12.7709V22.0714C15.926 22.5564 16.3196 22.95 16.8046 22.95C17.2896 22.95 17.6832 22.5564 17.6832 22.0714V12.7709L21.3038 16.3914C21.6473 16.735 22.2034 16.735 22.5461 16.3914C22.8896 16.0479 22.8896 15.4927 22.5461 15.1492L17.576 10.1791C17.3651 9.96826 17.077 9.90326 16.8037 9.95067C16.5313 9.90234 16.2423 9.96826 16.0314 10.1791L11.0614 15.1492C10.7178 15.4927 10.7178 16.0488 11.0614 16.3914C11.4049 16.7341 11.9619 16.735 12.3055 16.3914Z" fill="#0074C7" />
      </svg>
    </div>
  );
};

IncrementArrowIcon.props = {
  onClick: PropTypes.func,
}

IncrementArrowIcon.defaultProps = {
  onClick: () => { },
}

export default IncrementArrowIcon;
